<template>
  <div class="zoox-component zoox-tabs-vertical" :class="classes">
    <v-tabs
      ref="tabs"
      vertical
      show-arrows
      next-icon="$keyboard_arrow_right_rounded"
      prev-icon="$keyboard_arrow_left_rounded"
      :style="'--vertical-tab-gap: ' + gap + 'px'"
      :color="color"
      :dark="dark"
      :grow="grow"
      :value="appliedTab"
      @change="onChangeTab"
    >
      <v-tab
        v-for="tab of tabs"
        :key="tab.id"
        class="zoox-tab"
        :disabled="tab.disabled"
      >
        <span class="tab-text">
          {{ tab.text }}
        </span>
        <v-icon
          v-if="tab.icon"
          class="zoox-tab-icon ml-1"
          :color="tab.iconColor"
        >
          {{ tab.icon }}</v-icon
        >
      </v-tab>

      <v-tabs-items
        class="zoox-tab-items"
        :touchless="touchless"
        :value="appliedTab"
        @change="onChangeTab"
      >
        <v-tab-item
          v-for="(tab, index) of tabs"
          :key="index"
          class="zoox-tab-item"
        >
          <!--@slot Slot referente a tab selecionada. Seu nome é referente ao id de cada tab -->
          <slot :name="tab.id" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
/**
 * @displayName Tabs
 */
export default {
  name: 'ZTabsVertical',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Abas para serem criadas.
     * @typedef Object {text:string,id:number,string}
     */
    tabs: {
      type: Array,
      required: true,
    },
    /**
     * Valor do v-model
     *
     * @modelName value
     */
    value: {
      type: [String, Number],
      default: null,
    },
    /**
     * Flag para indicar que a tab deve ocupar todo o espaço disponível
     */
    grow: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para indicar que a cor precisa de um tema escuro
     */
    dark: {
      type: Boolean,
      default: false,
    },
    /**
     * Cor das abas e do slider caso seja do tipo android
     */
    color: {
      type: String,
    },
    /**
     * Flag para indicar que é sem touch. Não será passada de aba usando arrastar
     */
    touchless: {
      type: Boolean,
      default: false,
    },
    /**
     * Quantidade de gap para se utilizar entre as abas
     */
    gap: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      currentTab: null,
    }
  },
  computed: {
    appliedTab() {
      return this.value !== null
        ? this.tabs.findIndex((tab) => tab.id === this.value)
        : this.currentTab
    },
  },
  mounted() {
    if (this.value === null) {
      this.setTabById(this.tabs[0].id)
    }
  },
  methods: {
    /**
     * Método que permite escolher a tab programaticamente
     * @param {string} id - ID da aba que quer selecionar
     * @public
     */
    setTabById(id) {
      const tabIndex = this.tabs.findIndex((t) => t.id === id)

      if (tabIndex < 0) {
        throw new Error('tab não encontrada')
      } else {
        this.currentTab = tabIndex
        this.$refs.tabs.internalLazyValue = tabIndex
      }
    },
    onChangeTab(value) {
      /**
       * Evento emitido ao trocar de aba
       *
       * @property {string} tabId - ID da aba selecionada
       */
      this.$emit('change', this.tabs[value].id)
      if (this.value === null) {
        this.currentTab = value
      }
    },
    /**
     * Retorna o ID ta tab atual
     * @public
     */
    getCurrentTab() {
      return this.tabs[this.tab]
    },
  },
}
</script>

<style lang="scss">
.zoox-tabs-vertical {
  height: 100%;
  width: 100%;

  .v-slide-group {
    display: inline-block !important;
  }

  .v-slide-group__content {
    row-gap: var(--vertical-tab-gap);
  }

  .tab-text {
    font-size: var(--component-tab-md-text-size) !important;
  }

  .zoox-tab-items {
    height: calc(100% - 45px);

    > .v-window__container {
      height: 100%;
    }

    .zoox-tab-item {
      height: 100%;
    }
  }

  .v-tabs,
  .v-item-group,
  .v-window {
    background-color: transparent !important;
  }

  .zoox-tab {
    height: var(--component-tab-md-size) !important;
  }
}
</style>
